import styles from "./Skeleton.module.css";

type Props = {
  variant?: "page" | "card-list" | "form";
  lines?: number;
};

export function Skeleton({ variant = "page", lines = 3 }: Props) {
  if (variant === "card-list") {
    return (
      <div className={styles.stack} aria-hidden="true">
        {Array.from({ length: lines }).map((_, i) => (
          <div key={i} className={styles.card}>
            <div className={styles.line} style={{ width: "68%" }} />
            <div className={styles.line} style={{ width: "42%" }} />
          </div>
        ))}
      </div>
    );
  }
  if (variant === "form") {
    return (
      <div className={styles.stack} aria-hidden="true">
        <div className={styles.line} style={{ width: "40%", height: 28 }} />
        <div className={styles.block} style={{ height: 44 }} />
        <div className={styles.block} style={{ height: 120 }} />
        <div className={styles.block} style={{ height: 44 }} />
      </div>
    );
  }
  return (
    <div className={styles.stack} aria-hidden="true">
      <div className={styles.line} style={{ width: "55%", height: 28 }} />
      <div className={styles.line} style={{ width: "35%" }} />
      <div className={styles.block} style={{ height: 72 }} />
      <div className={styles.block} style={{ height: 120 }} />
    </div>
  );
}
